<template>
    <div
        class="min-h-screen bg-gray-50 flex flex-col justify-center py-6 sm:px-6 lg:px-8"
    >
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <a href="/">
                <svg-vue
                    class="mx-auto h-12 w-12"
                    icon="logo-leaf"
                    alt="Nutreance"
                />
            </a>

            <h2 class="mt-6 text-center text-3xl font-bold text-gray-900">
                Reset Password
            </h2>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form
                    ref="form"
                    action="/password/email"
                    method="POST"
                    @submit.prevent="onSubmit(form)"
                >
                    <input type="hidden" name="_token" :value="csrf" />

                    <div class="mt-3 mb-6">
                        <label
                            for="email"
                            class="block text-sm font-medium text-gray-700"
                        >
                            Email
                        </label>
                        <div class="mt-1 relative rounded-md shadow-sm">
                            <input
                                :ref="refs.email"
                                v-model="inputs.email"
                                id="email"
                                name="email"
                                type="email"
                                autocomplete="email"
                                required
                                :class="[
                                    hasError(errors, 'email')
                                        ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 pr-10'
                                        : 'focus:ring-nutreance-green focus:border-nutreance-green',
                                    'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm',
                                ]"
                                :aria-invalid="
                                    hasError(errors, 'email') ? 'true' : 'false'
                                "
                                :aria-describedby="
                                    hasError(errors, 'email')
                                        ? 'email-error'
                                        : ''
                                "
                            />
                            <div
                                v-if="hasError(errors, 'email')"
                                class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                            >
                                <ExclamationCircleIcon
                                    class="h-5 w-5 text-red-500"
                                    aria-hidden="true"
                                />
                            </div>
                        </div>
                        <p
                            v-if="hasError(errors, 'email')"
                            class="mt-2 text-sm text-red-600"
                            id="email-error"
                        >
                            {{ error(errors, "email") }}
                        </p>
                    </div>

                    <div class="mt-6 mb-3">
                        <button
                            name="send_link"
                            type="submit"
                            class="w-full flex justify-center items-center py-3 px-6 border border-transparent rounded-md shadow-sm font-medium text-white bg-nutreance-green hover:bg-nutreance-green-darker focus:outline-none"
                        >
                            <LoadingIcon
                                v-if="submitted"
                                class="h-5 w-5 mr-2"
                            />
                            <KeyIcon
                                v-else
                                class="h-5 w-5 mr-2"
                                aria-hidden="true"
                            />
                            Send Password Reset Link
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { ExclamationCircleIcon, KeyIcon } from "@heroicons/vue/solid";
import { useForm } from "../../functions/useForm";
import LoadingIcon from "../LoadingIcon.vue";

const props = defineProps<{
    csrf?: string;
    errors?: any;
    old?: any;
}>();

const { error, hasError, oldInput, onSubmit, submitted } = useForm();
const form = ref<any>(null);
const refs = {
    email: ref<any>(null),
};
const inputs = reactive({
    email: oldInput(props.old, "email"),
});

onMounted(() => refs.email.value.focus());
</script>
